import _extends from "@babel/runtime-corejs3/helpers/extends";
import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import * as _ from "../util/lodash";
import React from "react";

var withRefs = function withRefs(refsMap) {
  return function (BaseComponent) {
    var factory = function factory(props) {
      return /*#__PURE__*/React.createElement(BaseComponent, props);
    };

    return /*#__PURE__*/function (_React$Component) {
      _inheritsLoose(_class, _React$Component);

      function _class(props) {
        var _this;

        _this = _React$Component.call(this, props) || this;
        _this.state = {
          rerender: false
        };
        return _this;
      }

      var _proto = _class.prototype;

      _proto.render = function render() {
        var _this2 = this;

        var refProps = _reduceInstanceProperty(_).call(_, refsMap, function (acc, setRefName, refName) {
          acc.refs[refName] = _this2[refName];
          /* React calls this once on mount, with the element, and once on unmount, with null */

          acc[setRefName] = function (element) {
            acc.refs[refName] = _this2[refName] = element;
          };

          return acc;
        }, {
          refs: {}
        });

        return factory(_extends({}, this.props, refProps));
      };

      return _class;
    }(React.Component);
  };
};

export default withRefs;
//# sourceMappingURL=with-refs.js.map